//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {

        }
    },
    //生命周期之挂载完成
    methods: {
        goAgreement(){
            this.$router.push({path: '/userAgreement'});
        }
    },
    created: function(){
        document.title = '关于我们';
    }
}



// WEBPACK FOOTER //
// ./src/views/aboutUs/index.vue